import React, { useState, useCallback, useEffect} from 'react'
import styled from 'styled-components'
import DPlayer from 'dplayer'

// components
import Modal, { ModalProps } from '../../components/bakery/Modal'
import Row  from '../../components/Row'

const VedioModal = styled(Row)`
  position: fixed;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
    width: 290px;
  `}
`

const VedioCard = styled(Row)`
  flex-direction: column;
  font-family: Baloo Da;
  position: relative;
  height: auto;
  .dplayer-controller {
    height: 0px!important;
    overflow: hidden!important;
  }
  .video .dplayer-controller {
    height: 41px!important;
    overflow: visible!important;
  }
`

const VedioPlay = styled.div`
  width: 386px;
  height: 515px;
  border-radius: 10px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 258px;
    height: 344px;
  `}
`

interface PlayModalProps extends ModalProps {
  video: any
  isMyArtwork: any
}
// {video, isMyArtwork, bakeBalance = 0, allowanceBuy}

const PlayModal: React.FC<PlayModalProps> = ({
  onDismiss,
  video = {
    tokenId: '',
    name: '',
    description: '',
    imageUrl: '',
    fileUrl: '',
    price: '',
    attributes: {
      artist: '',
      edition: '',
      image_min: '',
      public_profile_link: ''
    },
    nftType: 0,
    auctionPrice: ''
  }
}) => {

  const p: any = null
  const [player, setPlayer] = useState(p)
  const [videoplay, setVideoplay] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (videoplay) {
      const dp = new DPlayer({
        container: videoplay,
        autoplay: true,
        mutex: true,
        video: {
          url: video.fileUrl
        }
      })
      setPlayer(dp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoplay])

  useEffect(() => {
    if (player) {
      player.on('canplaythrough', () => {
        let p = videoplay
        if (p) {
          p.className = `${p.className + ' video'}`
        }
      })
    }
  }, [player,videoplay])

  const dismiss = useCallback(async () => {
    if (player) {
      player.destroy()
    }
    if (onDismiss) {
      onDismiss()
    }
  }, [onDismiss, player])

  return (
    <VedioModal onClick={dismiss}>
      <Modal maxWidth={386} backgroundColor="transparent" padding="0px">
        <VedioCard onClick={(event:any) => {event.stopPropagation()}}>
          <VedioPlay ref={setVideoplay as any}></VedioPlay>
        </VedioCard>
      </Modal>
    </VedioModal>
  )
}
export default PlayModal
